import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  constructor(private http: HttpClient) { }

  /**
   * Obtiene los videos embebidos configurados
   * @returns Observable con la respuesta del servidor
   */
  getEmbeddedVideos(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/embeddedVideos`);
  }

  /**
   * Obtiene todos los tipos de usuario
   */
  getUserTypes(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/user-types`);
  }

  /**
   * Obtiene un tipo de usuario por su ID
   */
  getUserTypeById(id: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/user-types/${id}`);
  }

  /**
   * Obtiene todos los tipos de suscripción
   */
  getSubscriptionTypes(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/subscription-types`);
  }

  /**
   * Obtiene un tipo de suscripción por su ID
   */
  getSubscriptionTypeById(id: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/subscription-types/${id}`);
  }

  /**
   * Obtiene todos los estados de suscripción
   */
  getSubscriptionStatuses(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/subscription-statuses`);
  }

  /**
   * Obtiene todos los estados de usuario
   */
  getUserStatuses(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/user-statuses`);
  }

   /**
   * Obtiene todos los tipos de coaches
   */
  getCoachTypes(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/coach-types`);
  }

   /**
   * Obtiene todos los tipos de coaches
   */
  getExpertCategories(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/expert-categories`);
  }

  /**
   * Obtiene todos los permisos para customers
   */
  getCustomerPermissions(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/customer-permissions`);
  }

  // ========== MÉTODOS PARA DIMENSIONES (ACADEMY CATEGORIES) ==========

  /**
   * Obtiene todas las dimensiones (Academy Categories)
   */
  getDimensions(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/dimensions`);
  }

  /**
   * Obtiene una dimensión por su ID
   */
  getDimensionById(id: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/configurations/dimensions/${id}`);
  }

  /**
   * Crea una nueva dimensión (Academy Category)
   */
  createDimension(dimension: { name: string; description?: string }): Observable<any> {
    return this.http.post(`${environment.apiUrl}/configurations/dimensions`, dimension);
  }

  /**
   * Actualiza una dimensión existente
   */
  updateDimension(id: string, dimension: { name: string; description?: string }): Observable<any> {
    return this.http.put(`${environment.apiUrl}/configurations/dimensions/${id}`, { ...dimension, id });
  }

  /**
   * Elimina una dimensión
   */
  deleteDimension(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/configurations/dimensions/${id}`);
  }

  // ========== MÉTODOS MEJORADOS PARA EXPERT CATEGORIES ==========

  /**
   * Crea una nueva categoría de experto
   */
  createExpertCategory(category: { name: string; description?: string }): Observable<any> {
    return this.http.post(`${environment.apiUrl}/configurations/expert-categories`, category);
  }

  /**
   * Actualiza una categoría de experto existente
   */
  updateExpertCategory(id: string, category: { name: string; description?: string }): Observable<any> {
    return this.http.put(`${environment.apiUrl}/configurations/expert-categories/${id}`, { ...category, id });
  }

  /**
   * Elimina una categoría de experto
   */
  deleteExpertCategory(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/configurations/expert-categories/${id}`);
  }
} 